import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { RegisterComponent } from './auth/register/register.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { Error404Component } from './auth/error-404/error-404.component';
import { Error500Component } from './auth/error-500/error-500.component';
import { ComingSoonComponent } from './auth/coming-soon/coming-soon.component';
import { UnderMaintenanceComponent } from './auth/under-maintenance/under-maintenance.component';
import { LoginComponent } from './auth/login/login.component';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from '../enviroments/environments';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/core/service/auth-interceptor.service';
import { SharedModule } from './shared/shared-module';
import { SocialLoginModule, FacebookLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { GarantieregelingComponent } from './garantieregeling/garantieregeling.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    RegisterComponent,
    ChangePasswordComponent,
    Error404Component,
    Error500Component,
    ComingSoonComponent,
    UnderMaintenanceComponent,
    GarantieregelingComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    NgScrollbarModule,
    NgxStripeModule.forRoot(environment.stripePublishableKey),
    SocialLoginModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
    },
    provideAnimationsAsync(),
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('FACEBOOK_APP_ID')
          }
        ],
        onError: (err: any) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
